import { render, staticRenderFns } from "./uploadRecord.vue?vue&type=template&id=5a633f1d&scoped=true&"
import script from "./uploadRecord.vue?vue&type=script&lang=js&"
export * from "./uploadRecord.vue?vue&type=script&lang=js&"
import style0 from "./uploadRecord.vue?vue&type=style&index=0&id=5a633f1d&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a633f1d",
  null
  
)

export default component.exports